import {
  HistoricoSolicitacaoListParams,
  HistoricoSolicitacaoListResponse,
} from "@/models/auction-historico.model";
import { axiosLeilaoConsignadoTrabalhadorInstance } from "./axiosInstance";

const USE_MOCK_AUCTION_PROPOSALS =
  import.meta.env.VITE_USE_AUCTION_MOCKS === "true";

/**
 * Lista, paginado, o histórico durável das solicitações de leilão (tabela
 * `leilao_solicitacao_historico`) — o registro que sobrevive ao expurgo do
 * Redis (TTL 10min), incluindo leilões perdidos e os que não disputamos
 * (NO_BID), que nunca viram `PropostaLeilao`.
 *
 * Endpoint: GET /api-consignado-trabalhador/v1/proposta-leilao/historico
 *
 * Query params iguais aos do `/proposta-leilao/redis`:
 *  - pagina, tamanho_pagina
 *  - status (CSV; aceita também NO_BID)
 *  - codigo_lote
 *  - search_term (CPF ou número da solicitação)
 */
export async function getAuctionHistoricoSolicitacoes(
  params: HistoricoSolicitacaoListParams,
): Promise<HistoricoSolicitacaoListResponse> {
  if (USE_MOCK_AUCTION_PROPOSALS) {
    const { getMockAuctionHistoricoSolicitacoes } = await import(
      "@/mocks/auctionHistorico.mock"
    );
    return getMockAuctionHistoricoSolicitacoes(params);
  }

  const queryParams = new URLSearchParams();
  queryParams.set("pagina", String(params.page));
  queryParams.set("tamanho_pagina", String(params.pageSize));

  if (params.statuses?.length) {
    queryParams.set("status", params.statuses.join(","));
  }

  const codigoLote = params.codigoLote?.trim();
  if (codigoLote) {
    queryParams.set("codigo_lote", codigoLote);
  }

  const searchTerm = params.searchTerm?.trim();
  if (searchTerm) {
    queryParams.set("search_term", searchTerm);
  }

  const { data } =
    await axiosLeilaoConsignadoTrabalhadorInstance.get<HistoricoSolicitacaoListResponse>(
      "/api-consignado-trabalhador/v1/proposta-leilao/historico",
      { params: queryParams },
    );

  return data;
}
